import "normalize.css"
import "./css/main.scss";
import {createApp} from 'vue'
import App from './App.vue'
import './registerServiceWorker'

import onClickOut from "@/components/common/mixins/onClickOut"
import router from "@/router";
import axios from "axios";
import { initSentry } from "./sentry";

const axiosClient = axios.create({
  withCredentials: false
})

const app = createApp(App)

initSentry(app)

app.use(router)
app.mixin(onClickOut)

app.config.errorHandler = (error) => {
  console.error(error)
}

const mounted = app.mount("#app")

export {app, mounted, axiosClient}
